import { transport as ogTransport } from '@opengov/transport';

import { RecordOf } from '@opengov/compose-app/immutable';

export const RequestStatus = RecordOf<IRequestStatus>({ active: false, error: null });

export interface IRequestStatus {
  active: boolean;
  error: any;
}

export const transport = ogTransport.headers({
  'Cache-Control': 'no-cache',
  Pragma: 'no-cache'
});
